import React from 'react';

import { uiStateStoreInstance } from '../Stores/UIStateStore';

export default function GetProtectedComponent(WrappedComponent) {
  return class HOC extends WrappedComponent {
    render() {
      const ProtectedComponent = this.props.protectedComponent;
      if (!uiStateStoreInstance.adminMode) {
        return super.render();
      }
      return <ProtectedComponent {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/libs/ProtectedHOC.js